import React from 'react';

const tabs = [
  { id: 'chat',        label: 'AI Chat',      shortLabel: 'Chat',  icon: 'fa-comment-dots' },
  { id: 'collections', label: 'Collections',  shortLabel: 'AR',    icon: 'fa-money-bill-wave' },
  { id: 'inventory',   label: 'Inventory',    shortLabel: 'Stock', icon: 'fa-boxes-stacked' },
  { id: 'sales',       label: 'Sales',        shortLabel: 'Sales', icon: 'fa-handshake' },
  { id: 'performance', label: 'Performance',  shortLabel: 'Perf',  icon: 'fa-gauge-high' },
];

const DashboardTabs = ({ activeTab, setActiveTab, onMenuClick }) => {
  return (
    <div className="glass border-b z-10 flex-shrink-0" style={{ borderColor: 'var(--glass-border)' }}>
      <div className="flex items-center gap-0.5 px-1.5 md:px-3 py-1 md:py-1.5">

        {/* ── Hamburger — mobile only ── */}
        <button
          onClick={onMenuClick}
          className="md:hidden flex-shrink-0 flex flex-col items-center justify-center w-12 h-12 rounded-xl transition-all duration-200 hover:bg-indigo-50 active:scale-95"
          style={{ color: 'var(--text-secondary)' }}
          aria-label="Open navigation"
        >
          <i className="fas fa-bars text-lg"></i>
          <span className="text-[9px] font-semibold mt-0.5 uppercase tracking-wide">Menu</span>
        </button>

        {/* ── Tab strip ── */}
        <div className="tabs-scroll flex items-center gap-0.5 md:gap-1 overflow-x-auto flex-1">
          {tabs.map(tab => {
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                id={`tab-${tab.id}`}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  flex flex-col md:flex-row items-center justify-center
                  gap-0.5 md:gap-2
                  px-2.5 md:px-4 py-1.5 md:py-2
                  rounded-xl font-medium
                  whitespace-nowrap flex-shrink-0
                  transition-all duration-200
                  min-w-[52px] md:min-w-0
                  active:scale-95
                  ${isActive
                    ? 'tab-active'
                    : 'hover:bg-gray-100/70'
                  }
                `}
                style={!isActive ? { color: 'var(--text-muted)' } : {}}
              >
                {/* Icon — larger on mobile */}
                <i className={`fas ${tab.icon} text-base md:text-xs`}></i>

                {/* Short label — mobile only */}
                <span className="md:hidden text-[10px] font-semibold leading-none">
                  {tab.shortLabel}
                </span>

                {/* Full label — desktop only */}
                <span className="hidden md:inline text-sm">
                  {tab.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DashboardTabs;
